import React from 'react'

const Header = () => {
  return (
    <header>
      <div className='container'>
        <div className='logo flex'>
          <div className='img-div'>
          </div>
          <div className='name-title flex flex-column flex-column-start'>
            <h4>Mahmoud Safaya</h4>
            <h5 className='perGreen'>Front End Developer - React.js</h5>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
